import { Box, Container, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

const Styled = {
    Container: styled(Container)({
        height: '100%',
        minHeight: 'fit-content',
        width: '100vw',
        display: 'flex',
    }),
    LeftBox: styled(Box)(({ theme }) => {
        return {
            [theme.breakpoints.up('xs')]: {
                width: '100%',
            },
            [theme.breakpoints.up('md')]: {
                width: '50%',
            },
            minHeight: 'fit-content',
            marginTop: '16px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            flexDirection: 'column',
        };
    }),
    RightBox: styled(Box)(({ theme }) => {
        return {
            [theme.breakpoints.up('xs')]: {
                display: 'none',
            },
            [theme.breakpoints.up('md')]: {
                display: 'flex',
            },
            width: '50%',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgb(52, 32, 93)',
        };
    }),
    LogoContainer: styled(Box)(({ theme }) => ({
        maxWidth: '20rem',
        height: '100%',
        minHeight: 'fit-content',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        [theme.breakpoints.down('sm')]: {
            margin: '16px',
        },
    })),
    FooterContainer: styled(Box)({
        maxWidth: '20rem',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        bottom: 20,
        margin: '32px 0px 16px 0px',
    }),
    FooterLink: styled(Link)(({ theme }) => ({
        width: 'fit-content',
        justifyContent: 'center',
        display: 'flex',
        fontSize: 12,
        fontWeight: 900,
        color: theme.palette.text.light,
        '&:hover': {
            color: theme.palette.primary.main,
        },
        transition: ' color 0.2s',
    })),
};

export { Styled };
